import React, { Component } from "react";
import { Helmet } from "react-helmet";

import Logoz from "../files/Stech_Logos.zip";

class About extends Component {
  componentDidMount() {
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("root").classList.remove("affiliate");
    document.getElementById("foo").classList.add("overflow");
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - About Us</title>
          <meta name="description" content="STech - About us pages" />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left" />
            <div className="right">
              <h1>About Us</h1>
              <h2>STech – the Platform solution</h2>
            </div>
          </div>
        </header>
        <section className="clearfix fadeInUp">
          <div className="container about">
            <div className="left">
              <div className="info">
                <div className="bar" />
                <h1>Looking for a greater omni—channel solution?</h1>
                <p>
                  Enable seamless, single-wallet betting on all channels,
                  devices and land-based touchpoints
                </p>
                <a href="/">Find out more →</a>
              </div>
            </div>
            <div className="right">
              <div className="content fadeInUp">
                <p>
                  The STech Platform is one of a kind - we deliver a new
                  platform in days and weeks, not months and years. With STech
                  as a partner, you can be live in a couple of days with your
                  iGaming brand.
                </p>

                <p>
                  There are a number of reasons to use the STech platform. It is
                  hosted on a Content Delivery Network (CDN), not a single
                  server. This allows unbeatable speeds and performances, with
                  fast and easy rendering of ever-changing data.
                </p>

                <p>
                  Our platform provides everything needed for fast market entry
                  for our customers with the best sportsbook and casino
                  products, an extensive payment gateway, bonus engine, CRM
                  system and dedicated customer support.
                </p>

                <p>
                  Behind STech Technology is a super-skilled team of technical,
                  marketing and operational experts with decades of experience
                  and knowledge from the industry. We will guide you in the
                  direction you need.
                </p>

                <a
                  className="logoz"
                  href={Logoz} 
                  title="Download Stech Logo Kit"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Stech Logo Kit
                  <span></span>
                </a>

                <h3 className="hide">Who are the key leaders at STech?</h3>

                <ul className="row team hide">
                  <li>
                    <div className="flex">
                      <h3>Dan Vikman</h3>
                    </div>
                    <p>
                      has a background in journalism and the media. He has been
                      in the i-Gaming and online industry since 2000, working
                      with CRM, PR, marketing, events and world class
                      ambassadors.
                    </p>
                  </li>
                  <li>
                    <div className="flex">
                      <h3>Niclas Ruthberg</h3>
                    </div>
                    <p>
                      has a 15 year long experience in online gaming with a
                      wide, high-level background in being Head of Gaming
                      Operations at Casino Room, country manager for Unibet, and
                      handling operations at OnGame.
                    </p>
                  </li>
                  <li>
                    <div className="flex">
                      <h3>Jessica Portelli Melkersson</h3>
                    </div>
                    <p>
                      has 18 years long experience in online gaming being team
                      leader, head of quality and training, senior fraud analyst
                      and head of support.
                    </p>
                  </li>
                  <li>
                    <div className="flex">
                      <h3>Damjan Trumbic</h3>
                    </div>
                    <p>
                      is a casino expert with 15 years’ experience in the online
                      gaming industry on all levels of marketing, sales and
                      customer programs.
                    </p>
                  </li>
                </ul>
              </div>
              <div
                className="facts wow fadeInUp hide"
                data-wow-duration="0.5s"
                data-wow-delay="0.25s"
              >
                <h1>Facts &amp; Figures</h1>
                <ul className="u1">
                  <li className="box">
                    <h4>Employees</h4>
                    <h5>50+</h5>
                  </li>
                  <li className="box">
                    <h4>Regulated Markets</h4>
                    <h5>5+</h5>
                  </li>
                </ul>
                <ul className="u2">
                  <li className="box">
                    <h4>Years of Experience</h4>
                    <h5>10+</h5>
                  </li>
                  <li className="box">
                    <h4>International Offices</h4>
                    <h5>2</h5>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default About;
